// @flow
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import type { PureQueryOptions } from '@apollo/client';

import SegmentEditor from './SegmentEditor';
import type { GlobalSegmentCategory, SegmentCategory } from './types';
import { GET_CLIENT_SEGMENT_CATEGORIES, CREATE_CLIENT_SEGMENT_CATEGORY } from './queries';

type SegmentEditorContainerProps = {
  clientId: string,
  availableCategories: Array<GlobalSegmentCategory>,
  segmentCategory: ?SegmentCategory,
  isInitialEditor: boolean,
};
export default function SegmentEditorContainer({
  clientId,
  availableCategories,
  segmentCategory,
  isInitialEditor,
}: SegmentEditorContainerProps) {
  const mutationRefetchQueries: Array<PureQueryOptions> = [
    {
      query: GET_CLIENT_SEGMENT_CATEGORIES,
      variables: { clientId },
    },
  ];

  return (
    <Mutation mutation={CREATE_CLIENT_SEGMENT_CATEGORY} refetchQueries={mutationRefetchQueries}>
      {createClientSegmentCategory => (
        <SegmentEditor
          clientId={clientId}
          availableCategories={availableCategories}
          segmentCategory={segmentCategory}
          isInitialEditor={isInitialEditor}
          onCategoryAssigned={({ id }: GlobalSegmentCategory) =>
            createClientSegmentCategory({
              variables: {
                clientSegmentCategory: {
                  clientId,
                  segmentCategoryId: id,
                },
              },
            })
          }
        />
      )}
    </Mutation>
  );
}
